import BodyText from 'components/Luxkit/Typography/BodyText'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'
import TextLink from 'components/Luxkit/TextLink'
import Image from 'components/Common/Image'
import { mediaQueryUp } from 'components/utils/breakpoint'
import Group from 'components/utils/Group'
import ContactUSP from '../ContactUSP'

const USPContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${rem(24)};
  padding-top: ${rem(40)};
  border-top: 1px solid ${props => props.theme.palette.neutral.default.five};
  align-items: center;
  height: fit-content;

  ${mediaQueryUp.tablet} {
    display: flex;
    gap: ${rem(40)};
    padding-top: ${rem(24)};
  }
`

const StyledContactUSP = styled(ContactUSP)`
  ${mediaQueryUp.tablet} {
    max-width: ${rem(330)};
  }
`

const USP = styled(Group)`
  ${mediaQueryUp.tablet} {
    max-width: ${rem(330)};
  }
`

const ImageWrapper = styled.div`
  min-width: ${rem(68)};
  height: ${rem(68)};

  ${mediaQueryUp.tablet} {
    min-width: ${rem(84)};
    height: ${rem(84)};
  }
`

interface Props {
  isPrivateRequest?: boolean;
  onRequestPrivateTour: () => void
}

function TourV2USP(props: Props) {
  const {
    isPrivateRequest,
    onRequestPrivateTour,
  } = props

  return <USPContainer>
    <StyledContactUSP />
    {isPrivateRequest &&
      <USP
        gap={16}
        tabletGap={20}
        direction="horizontal-reverse"
        tabletDirection="horizontal"
        verticalAlign="start"
        tabletVerticalAlign="center"
        horizontalAlign="space-between"
        tabletHorizontalAlign="start"
      >
        <ImageWrapper>
          <Image fit="center" id="private-request-20230523" />
        </ImageWrapper>
        <Group direction="vertical" gap={4}>
          <BodyText variant="medium" weight="bold">
            Make this a private departure
          </BodyText>
          <BodyText variant="medium" colour="neutral-three">
            Travel exclusively with family & friends at a time that works best for you.
          </BodyText>
          <TextLink size="medium" weight="bold" onClick={onRequestPrivateTour}>Request private departure</TextLink>
        </Group>
      </USP>}
  </USPContainer>
}

export default TourV2USP
